import { Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";
import {
    IndicatorTrend,
    PolicyTabStats,
} from "@/_models/stats-policy.interface";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { SpiChartComponent } from "@/components/safety-policy/policy-objectives/spi/spi-chart/spi-chart.component";

const INDICATOR_CARD_PLACEHOLDER_HEIGHT_PX = 220;

@Component({
    selector: "app-policy-type-stats",
    standalone: true,
    imports: [SharedComponentsModule, RouterLink, SpiChartComponent],
    templateUrl: "./policy-type-stats.component.html",
})
export class PolicyTypeStatsComponent {
    @Input() data: PolicyTabStats;
    @Input() indicatorTrends: IndicatorTrend[] = [];
    readonly indicatorCardPlaceholderHeightPx =
        INDICATOR_CARD_PLACEHOLDER_HEIGHT_PX;
}
